import React, { useContext, useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
import GraficoCallCenter from './GraficoCallCenter';
import { ContextGloball } from '../Context/ContextGlobal';
const server = process.env.REACT_APP_SERVER;

function GraficaCallCenter(props) {
    const {fecha,idSucursal,sucursales} = props;
    const [listaDatos, setListaDatos] = useState([]);
    const [maxValue, setMaxValue] = useState(0);
    function graficarFecha() {
        if (idSucursal !== 0 && fecha !== '') {
            //setLoading(true);
            const sucursal = sucursales.filter((item) => item.ID_SUCURSAL == idSucursal)[0]
            fetch(`${server}/graficos/getGraficoFecha`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    fecha, sucursal
                })
            })
                .then(res => res.json())
                .then(data => {
                    //setLoading(false);
                    if (data.error) {
                        MsgUtils.msgError(data.error);
                    } else {
                        setListaDatos(data.ok);
                        var lista = data.ok;
                        var max = 0;
                        for (var i = 0; i < lista.length; i++) {
                            if (max < lista[i].promedio) {
                                max = lista[i].promedio;
                            }
                        }
                        setMaxValue(max);
                    }
                    //setLoading(false);
                })
                .catch(err => console.log(err));
        } else {
            MsgUtils.msgError("Seleccione la sucursal y una fecha por favor para graficar ....")
        }
    }
    useEffect(() => {
        graficarFecha();
    }, [])
    return (
        <GraficoCallCenter datos={listaDatos} maxValue={maxValue} />
    )
}

export default GraficaCallCenter